import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Formik, Form, Field } from "formik";
import TextInput from "./TextInput";
import Button from "./CustomButton";
import Icon from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { isFetchingProducts, actions } from "../modules/market";
import SelectCategoriesFormik from "./SelectCategoriesFormik";
import CategoryBadge from "./CategoryBadge";
import _ from "lodash/fp";

const initialValues = { name: "", categories: [] };

const ProductFilterForm = ({ submitting, onSubmit, onReset }) => {
  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit}>
      {({ values, resetForm }) => (
        <Form>
          <div className="container-fluid mb-3">
            <div className="row">
              <div className="col-12 col-sm">
                <Field
                  name="name"
                  placeholder="Product name"
                  component={TextInput}
                />
              </div>
              <div className="col-12 col-sm-auto mb-3">
                <Field name="categories" component={SelectCategoriesFormik} />
              </div>
              <div className="col-12 col-sm-auto mb-3">
                <Button block fill color="info" disabled={submitting}>
                  Search <Icon icon="search" />
                </Button>
              </div>
              <div className="col-12 col-sm-auto mb-3">
                <Button
                  type="button"
                  block
                  color="danger"
                  disabled={submitting}
                  onClick={() => {
                    resetForm(initialValues);
                    onReset();
                  }}
                >
                  Clear <Icon icon="times" />
                </Button>
              </div>
            </div>
            <div className="row">
              {_.map(
                category => (
                  <div className="col-6 col-sm-auto mb-2">
                    <CategoryBadge category={category} />
                  </div>
                ),
                values.categories
              )}
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

ProductFilterForm.propTypes = {
  submitting: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired
};

const SearchProductFilterForm = connect(
  state => ({
    submitting: isFetchingProducts(state)
  }),
  {
    setProductFilter: actions.setProductFilter,
    setCurrentPage: actions.setCurrentPage
  }
)(({ submitting, setProductFilter, setCurrentPage }) => {
  const onSubmit = useCallback(
    values => {
      setCurrentPage(1);
      setProductFilter({
        name: values.name,
        category_ids: _.map(cat => cat.id, values.categories).join(",")
      });
    },
    [setCurrentPage, setProductFilter]
  );
  const onReset = useCallback(() => {
    setCurrentPage(1);
    setProductFilter({
      name: "",
      category_ids: []
    });
  }, [setCurrentPage, setProductFilter]);
  return (
    <ProductFilterForm
      submitting={submitting}
      onSubmit={onSubmit}
      onReset={onReset}
    />
  );
});

export default SearchProductFilterForm;
